export default "__VITE_ASSET__B5BdS57U__"